<template>
  <div class="monthly-chart">
    <CCard>
      <CCardBody>
        <h5 class="text-primary">Monthly Applications Overview</h5>
        <div>
          <BasicBar
            :data="getMonthlyChartData"
            :height="300"
            :options="options"
          />
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import candidate from "@/containers/KSADashboard/candidate.json";
import BasicBar from "@/components/reusable/Charts/BasicBar.vue";
import { formatDateFormat, getRandomColor } from "../../helpers/helper";
export default {
  name: "MonthlyChart",
  components: {
    BasicBar,
  },
  computed: {
   getMonthWiseCount() {
      const counts = candidate.reduce((acc, item) => {
        const date = item.application_date;
        const program = item.Program;
        if(!acc[program]){
            acc[program] = {};
        }
        if (!acc[program][date]) {
          acc[program][date] = 0;
        }
        acc[program][date]++;
        return acc;
      }, {});
      return Object.entries(counts).map(([program, dates]) => ({
        name: program,
        backgroundColor: getRandomColor(),
        value: Object.entries(dates).map(([date, count]) => ({
          name: formatDateFormat(date, 'MMM YY'),
          value: count,
        })),
      }));
    },
    getMonthlyChartData() {
      const data = this.getMonthWiseCount;
      const res = data.map((item) => {
        return {
          name: item.name,
          values: item.value,
          backgroundColor: item.backgroundColor,
        };
      });
      return res;
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 0,
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
                fontStyle: "bold",
              },
              scaleLabel: {
                display: true,
                fontStyle: "bold",
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            color: "#fff",
            anchor: "end",
            align: "start",
            font: {
              weight: "bold",
              size: 12,
            },
            formatter: (value) => value,
          },
        },
      };
    },
  },
};
</script>
